import React from 'react'
import classNames from 'classnames'
import SvgIcon from '../SvgIcon'
import average from './average'


interface IAveragePillProps {
    className?: string
}

const AveragePill = ({ className }: IAveragePillProps) => {
    return (
        <div
            className={classNames(
                'flex shrink-0 items-center gap-x-1 border text-white h-5 px-1 rounded-sm w-max',
                className || 'bg-[#3b82f6]'
            )}
        >
            <SvgIcon icon={average} height={12} width={12} />
            <span className="text-xs leading-3">Average</span>
        </div>
    )
}

export default AveragePill
